import { useRef, useState } from 'react'

type UseCollapseOptions = {
  initialOpened?: boolean
  minHeight?: number | string
  enabled?: boolean
}

export const useCollapse = <ElementType extends Element = HTMLDivElement>(
  options?: UseCollapseOptions
) => {
  const { initialOpened = false, minHeight = 0, enabled = true } = options ?? {}

  const [opened, setOpened] = useState(initialOpened)
  const [contentHeight, setContentHeight] = useState<
    string | number | undefined
  >(initialOpened ? undefined : minHeight)
  const contentRef = useRef<ElementType>(null)

  const toggle = newVal => {
    if (typeof newVal !== 'boolean') newVal = !opened

    setOpened(newVal)

    const elementScrollHeight = contentRef?.current?.scrollHeight
    const scrollHeight = elementScrollHeight
      ? `${elementScrollHeight}px`
      : 'auto'
    setContentHeight(scrollHeight)

    if (!newVal) {
      setTimeout(() => setContentHeight(minHeight), 0)
    }
  }

  const handleTransitionEnd = () => {
    setContentHeight(prev => (prev === minHeight ? minHeight : undefined))
  }

  const contentProps = {
    ref: contentRef,
    style: {
      maxHeight: enabled ? contentHeight : undefined,
      overflow: !enabled || contentHeight === undefined ? undefined : 'hidden',
      transition: enabled ? 'max-height .1s ease-out' : undefined,
    },
    onTransitionEnd: handleTransitionEnd,
  }

  return { opened, toggle, contentProps }
}
